export const paths = {
  login: {
    path: '/login',
    getHref: (redirectTo?: string | null | undefined) =>
      `/login${redirectTo ? `?redirectTo=${encodeURIComponent(redirectTo)}` : ''}`
  },
  forgotPassword: {
    path: '/forgot-password',
    getHref: () => '/forgot-password'
  },
  changePassword: {
    path: '/change-password',
    getHref: () => '/change-password'
  },
  root: {
    path: '/',
    getHref: () => '/'
  },

  /* System */
  distributorManage: { path: '/distributor-manage', getHref: () => '/distributor-manage' },
  distributorManageCreate: {
    path: '/distributor-manage/create',
    getHref: () => '/distributor-manage/create'
  },
  distributorManageDetail: {
    path: '/distributor-manage/:id',
    getHref: (id: string) => `/distributor-manage/${id}`
  },
  distributorManageEdit: {
    path: '/distributor-manage/:id/edit',
    getHref: (id: string) => `/distributor-manage/${id}/edit`
  },

  /* Stock Master */
  stockMaster: { path: '/stock-master', getHref: () => '/stock-master' },
  /* Supplier Master */
  supplierMaster: {
    path: '/supplier-master',
    getHref: () => '/supplier-master'
  },
  supplierMasterCreate: {
    path: '/supplier-master/create',
    getHref: () => '/supplier-master/create'
  },
  supplierMasterDetail: {
    path: '/supplier-master/:id',
    getHref: (id: string) => `/supplier-master/${id}`
  },
  supplierMasterEdit: {
    path: '/supplier-master/:id/edit',
    getHref: (id: string) => `/supplier-master/${id}/edit`
  },

  /* Customers */
  customerMaster: {
    path: '/customer-master',
    getHref: () => '/customer-master'
  },
  customerMasterCreate: {
    path: '/customer-master/create',
    getHref: () => '/customer-master/create'
  },
  customerMasterDetail: {
    path: '/customer-master/:id',
    getHref: (id: string) => `/customer-master/${id}`
  },
  customerMasterEdit: {
    path: '/customer-master/:id/edit',
    getHref: (id: string) => `/customer-master/${id}/edit`
  },
  customerMasterProducts: {
    path: '/customer-master/:id/products',
    getHref: (id: string, is_active?: boolean) =>
      `/customer-master/${id}/products${is_active ? `?is_active=${is_active}` : ''}`
  },
  customerMasterEditProducts: {
    path: '/customer-master/:customer_id/products/:product_id/edit',
    getHref: (customer_id: string, product_id: string) =>
      `/customer-master/${customer_id}/products/${product_id}/edit`
  },

  /* Stockers */
  stockersList: { path: '/stockers', getHref: () => '/stockers' },

  /* Product Master */
  productMaster: {
    path: '/product-master',
    getHref: () => '/product-master'
  },
  productMasterCreate: {
    path: '/product-master/create',
    getHref: () => '/product-master/create'
  },
  productMasterDetail: {
    path: '/product-master/:id',
    getHref: (id: string) => `/product-master/${id}`
  },
  productMasterEdit: {
    path: '/product-master/:id/edit',
    getHref: (id: string) => `/product-master/${id}/edit`
  },

  /* Products */
  productsDetailMobile: {
    path: '/stockers/:stockId/products/:productId',
    getHref: (stockId: string, productId: string) => `/stockers/${stockId}/products/${productId}`
  },
  productsSelect: {
    path: '/stockers/:stockId/products',
    getHref: (stockId: string) => `/stockers/${stockId}/products`
  },

  /* Orders */
  ordersManagementList: {
    path: '/orders/management',
    getHref: (status?: string) => `/orders/management${status ? `?status=${status}` : ''}`
  },
  ordersManagementCreate: {
    path: '/orders/management/create',
    getHref: () => '/orders/management/create'
  },
  ordersManagementDetail: {
    path: '/orders/management/:id',
    getHref: (id: string) => `/orders/management/${id}`
  },
  ordersManagementEdit: {
    path: '/orders/management/:id/edit',
    getHref: (id: string) => `/orders/management/${id}/edit`
  },
  ordersManagementEmail: {
    path: '/orders/management/:id/email',
    getHref: (id: string) => `/orders/management/${id}/email`
  },
  ordersMissingList: {
    path: '/orders/missing-product',
    getHref: () => '/orders/missing-product'
  },
  ordersMissingCreate: {
    path: '/orders/missing-product/create',
    getHref: () => '/orders/missing-product/create'
  },
  ordersMissingDetail: {
    path: '/orders/missing-product/:id',
    getHref: (id: string) => `/orders/missing-product/${id}`
  },
  ordersMissingEdit: {
    path: '/orders/missing-product/:id/edit',
    getHref: (id: string) => `/orders/missing-product/${id}/edit`
  },
  ordersSalesBySupplier: {
    path: '/orders/sales-by-supplier',
    getHref: (month: string) => `/orders/sales-by-supplier${month ? `?month=${month}` : ''}`
  },

  /* Stock */
  inStock: { path: '/in-stock', getHref: () => '/in-stock' },
  inTransit: { path: '/in-transit', getHref: () => '/in-transit' },

  /* Inbound (Stock In) */
  inboundList: {
    path: '/inbound',
    getHref: (status?: string) => `/inbound${status ? `?status=${status}` : ''}`
  },
  inboundCreate: { path: '/inbound/create', getHref: () => '/inbound/create' },
  inboundDetail: {
    path: '/inbound/:id',
    getHref: (id: string) => `/inbound/${id}`
  },
  inboundEdit: {
    path: '/inbound/:id/edit',
    getHref: (id: string) => `/inbound/${id}/edit`
  },

  /* Outbound (Stock Out) */
  outboundList: {
    path: '/outbound',
    getHref: (status?: string) => `/outbound${status ? `?status=${status}` : ''}`
  },
  outboundCreate: {
    path: '/outbound/create',
    getHref: () => '/outbound/create'
  },
  outboundDetail: {
    path: '/outbound/:id',
    getHref: (id: string) => `/outbound/${id}`
  },
  outboundEdit: {
    path: '/outbound/:id/edit',
    getHref: (id: string) => `/outbound/${id}/edit`
  },

  /* NG Goods */
  ngGoodsHistoryList: {
    path: '/ng-goods/history',
    getHref: () => '/ng-goods/history'
  },
  ngGoodsHistoryCreate: {
    path: '/ng-goods/history/create',
    getHref: () => '/ng-goods/history/create'
  },
  ngGoodsHistoryDetail: {
    path: '/ng-goods/history/:id',
    getHref: (id: string) => `/ng-goods/history/${id}`
  },
  ngGoodsHistoryEdit: {
    path: '/ng-goods/history/:id/edit',
    getHref: (id: string) => `/ng-goods/history/${id}/edit`
  },
  /* Cart */
  cartList: { path: '/cart', getHref: () => '/cart' },
  cartConfirm: { path: '/cart/confirm', getHref: () => '/cart/confirm' },
  cartSuccess: { path: '/cart/success', getHref: () => '/cart/success' },

  /* History */
  historyList: { path: '/history', getHref: () => '/history' },

  /* Settings */
  settings: { path: '/settings', getHref: () => '/settings' },

  /* Sale */
  salesBuy: {
    path: '/sales-buy',
    getHref: (customer_id?: string, start_date?: string, end_date?: string) => {
      const qs = new URLSearchParams()
      if (customer_id) qs.append('customer_id', customer_id)
      if (start_date) qs.append('start_date', start_date)
      if (end_date) qs.append('end_date', end_date)
      const queryString = qs.toString()
      return `/sales-buy${queryString ? `?${queryString}` : ''}`
    }
  },
  salesReturn: {
    path: '/sales-return',
    getHref: (customer_id?: string, start_date?: string, end_date?: string) => {
      const qs = new URLSearchParams()
      if (customer_id) qs.append('customer_id', customer_id)
      if (start_date) qs.append('start_date', start_date)
      if (end_date) qs.append('end_date', end_date)
      const queryString = qs.toString()
      return `/sales-return${queryString ? `?${queryString}` : ''}`
    }
  },

  /* Purchase */
  purchaseBuy: {
    path: '/purchase-buy',
    getHref: (start_date?: string, end_date?: string) => {
      const qs = new URLSearchParams()
      if (start_date) qs.append('start_date', start_date)
      if (end_date) qs.append('end_date', end_date)
      const queryString = qs.toString()
      return `/purchase-buy${queryString ? `?${queryString}` : ''}`
    }
  },
  purchaseReturn: {
    path: '/purchase-return',
    getHref: (start_date?: string, end_date?: string) => {
      const qs = new URLSearchParams()
      if (start_date) qs.append('start_date', start_date)
      if (end_date) qs.append('end_date', end_date)
      const queryString = qs.toString()
      return `/purchase-return${queryString ? `?${queryString}` : ''}`
    }
  },

  /* Deliveries */
  selectMode: { path: '/select-mode', getHref: () => '/select-mode' },
  deliveries: {
    path: '/deliveries',
    getHref: (status?: string) => `/deliveries${status ? `?status=${status}` : ''}`
  },
  userMaster: { path: '/user-master', getHref: () => '/user-master' },

  deliveryStaff: { path: '/delivery', getHref: () => '/delivery' }
} as const

export type Paths = typeof paths
